import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import "../../css/others/Table.css";
import Pagination from "../../Reusablecomponents/Pagination";
import { apiCall } from "../../main/ApiCall";
import { ChecklistDetails } from "../../interFaces/interfaces";
const AdminViewChecklistDetails: React.FC = () => {
  const { localTemplateId } = useParams<{ localTemplateId: string }>();
  const location = useLocation();
  const { isIntegratedChecklist, controls = [] } = location.state || {};
  const [details, setDetails] = useState<ChecklistDetails | null>(null);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  useEffect(() => {
    const fetchChecklistDetails = async () => {
      if (!localTemplateId) return;
      setLoading(true);
      try {
        const checklist = await apiCall("get", `/api/local-templates/${localTemplateId}/questions/active`, null, { page: currentPage - 1, size: itemsPerPage });
        setDetails(checklist || { content: [] });
        setTotalElements(checklist.totalElements || 0);
        setTotalPages(checklist.totalPages || 0);
      } catch (error) {
        console.error("Error fetching checklist details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchChecklistDetails();
  }, [localTemplateId, currentPage, itemsPerPage]);
  const renderTableHeaders = () => {
    const controlHeaders = { pims: "PIMS", isms: "ISMS", bcms: "BCMS", cmmi: "CMMI", aims: "AIMS", soc1: "SOC 1", soc2: "SOC 2", qms: "QMS", erm: "ERM", itsm: "ITSM", ers: "ERS", ohs: "OHS" };
    return (
      <tr>
        <th>S.No.</th>
        <th className="header-width">Question</th>
        <th className="header-width">Expected Artifact</th>
        {!isIntegratedChecklist && <th>Control/Practice Area</th>}
        {controls.map((control: React.Key | null | undefined) => {
          if (typeof control === "string") {
            return <th key={control} className="header-width">{controlHeaders[control as keyof typeof controlHeaders] || control}</th>;
          }
          return <th key={String(control)}>{String(control)}</th>;
        })}
      </tr>
    );
  };
  const renderQuestionRow = (item: any, index: number) => {
    const getActualFieldName = (displayName: string): string => {
      const fieldMap: { [key: string]: string } = { "PIMS": "pims", "ISMS": "isms", "BCMS": "bcms", "CMMI": "cmmi", "AIMS": "aims", "SOC 1": "soc1", "SOC 2": "soc2", "QMS": "qms", "ERM": "erm", "ITSM": "itsm", "ERS": "ers", "OHS": "ohs" };
      return fieldMap[displayName] || displayName.toLowerCase().replace(/\s+/g, '');
    };
    return (
      <tr key={item.questionId}>
        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
        <td>{item.questionText || "Empty"}</td>
        <td>{item.expectedArtifact || "Empty"}</td>
        {!isIntegratedChecklist && <td>{item.practiceArea || "Empty"}</td>}
        {controls.map((control: React.Key | null | undefined) => {
          if (typeof control === "string") {
            const actualFieldName = getActualFieldName(control);
            return <td key={control}>{item[actualFieldName] || "Empty"}</td>;
          }
          return <td key={String(control)}>Empty</td>;
        })}
      </tr>
    );
  };
  const calculateColSpan = () => {
    let colSpan = 3;
    if (!isIntegratedChecklist) {
      colSpan += 1;
    }
    colSpan += controls.length;
    return colSpan;
  }
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Checklist Details</h2>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              {renderTableHeaders()}
            </thead>
            <tbody>
              {details?.content && details.content.length > 0 ? (
                details.content.map((item, index) => renderQuestionRow(item, index))
              ) : (
                <tr>
                  <td className="no-data" colSpan={calculateColSpan()}>No questions available for this checklist</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
    </div>
  );
};
export default AdminViewChecklistDetails;